import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { InventoryPage } from '@/features/inventory/pages/InventoryPage'

const searchSchema = z.object({
  tab: z.enum(['stock', 'movements', 'stock-takes', 'transfers', 'incentives']).catch('stock'),
})

export const Route = createFileRoute('/_app/inventory/')({
  validateSearch: searchSchema,
  component: InventoryPage,
})
